import React, { useEffect, useState } from "react";

import Context from "./Context";
import { useAuth } from "providers/Auth";
import { useToast } from "providers/Toast";
import { scheduleEventId } from "config/const";
import * as Client from "api/client";
import get from "lodash.get";

const Provider = ({ children }) => {
  const [activity, setActivity] = useState({});
  const [customerActivity, setCustomerActivity] = useState({});
  const [activityTime, setActivityTime] = useState([]);
  const [isBook, setIsBook] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);

  const { auth } = useAuth();
  const { danger, success } = useToast();

  const getActivity = () =>
    Client.getActivity(auth.idToken).then((res) => {
      if (!res.err) {
        setActivity(res);
        return true;
      } else {
        return false;
      }
    });

  const getCustomerActivityInfo = () =>
    Client.getCustomerActivityInfo(auth.userId, auth.idToken).then((res) => {
      if (!res.err) {
        //TODO: remove res.splice(-1)[0]
        const RSVP = res.find(({ status }) => status === "ACTIVE") || {};
        setCustomerActivity(RSVP);
        setIsBook(
          RSVP.scheduleEventId === scheduleEventId && RSVP.status === "ACTIVE"
        );
        setIsSignUp(RSVP.isSignup);
        return true;
      } else {
        return false;
      }
    });

  const bookActivity = (detail) =>
    Client.bookActivity(auth.userId, auth.idToken, detail).then((res) => {
      if (!res.error && !res.err) {
        setIsBook(true);
        setIsSignUp(false);
        setCustomerActivity(res);
        return true;
      } else {
        danger(get(res, "error.message", "預約失敗"));
        return false;
      }
    });

  const signupActivity = (code) =>
    Client.signupActivity(
      auth.userId,
      customerActivity.id,
      auth.idToken,
      code
    ).then((res) => {
      if (!res.error && !res.err) {
        setIsBook(true);
        setIsSignUp(true);
        success("簽到成功");
        return true;
      } else {
        danger(get(res, "error.message", "簽到失敗"));
        return false;
      }
    });

  const getActivityTime = async (startdate, enddate) => {
    try {
      const res = await Client.getActivityTime(
        auth.idToken,
        startdate,
        enddate
      );
      if (!res.error && !res.err) {
        setActivityTime(res);
        return { success: true, data: res };
      } else {
        const message = get(res, "error.message", "錯誤");
        danger(message);
        return { success: false, message };
      }
    } catch (error) {
      return { success: false, message: "錯誤" };
    }
  };

  const cancelActivity = async () => {
    if (isSignUp) return;
    const res = await Client.cancelActivity(
      auth.idToken,
      auth.userId,
      customerActivity.id
    );
    if (!res.error && !res.err) {
      setIsBook(false);
      setCustomerActivity({});
      return true;
    } else {
      const message = get(res, "error.message", "取消失敗");
      danger(message);
      return false;
    }
  };
  useEffect(() => {
    if (!auth.idToken || !auth.idToken.token || fetched) return;

    Promise.all([getActivity(), getCustomerActivityInfo()]).then(
      ([aState, cState]) => {
        setFetched(aState && cState);
      }
    );
  }, [auth]);

  const props = {
    activity,
    customerActivity,
    isBook,
    activityTime,
    bookActivity,
    signupActivity,
    getActivityTime,
    cancelActivity,
    isSignUp,
    fetched,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
